import { createRouter, createWebHistory } from "vue-router"
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/auth',
      redirect: "/login",
      component: () => import('@/layouts/Guest.vue'),
      meta: { isGuest: true },
      children: [
        { path: "/register", name: 'Register', component: () => import('@/pages/auth/Register.vue') },
        { path: "/login", name: 'Login', component: () => import('@/pages/auth/Login.vue') },
        { path: "/verify-email", name: 'VerifyEmail', component: () => import('@/pages/auth/VerifyEmail.vue') },
        { path: "/two-factor-challenge", name: 'TwoFactorChallenge', component: () => import('@/pages/auth/TwoFactorChallenge.vue') },
        { path: "/forgot-password", name: 'ForgotPassword', component: () => import('@/pages/auth/ForgotPassword.vue') },
        { path: "/reset-password/:token", name: 'ResetPassword', component: () => import('@/pages/auth/ResetPassword.vue') }
      ]
    },
    {
      path: '/team-invite',
      name: 'TeamInvite',
      component: () => import('@/pages/auth/TeamInvite.vue'),
    },
    {
      path: '/',
      component: () => import('@/layouts/Authenticated.vue'),
      meta: { requiresAuth: true },
      children: [
        { path: "/", name: 'Timeline', component: () => import('@/pages/Timeline.vue') },
        { path: "/timeline/:eventUlid", name: 'TimelineEvent', component: () => import('@/pages/Timeline.vue') },
        {
          path: "/activity/:eventUlid",
          redirect: (to) => ({
            name: 'TimelineEvent',
            params: { eventUlid: to.params.eventUlid },
            query: to.query,
          }),
        },
        {
          path: "/incidents",
          name: 'Incidents',
          component: () => import('@/pages/Incidents.vue'),
        },
        { path: "/projects", name: 'Projects', component: () => import('@/pages/Projects.vue') },
        { path: "/projects/:id", name: 'ProjectDetails', component: () => import('@/pages/ProjectDetails.vue') },
        { path: "/domains", name: 'Domains', component: () => import('@/pages/Domains.vue') },
        { path: "/domains/:id", name: 'DomainDetails', component: () => import('@/pages/DomainDetails.vue') },
        { path: "/servers", name: 'Servers', component: () => import('@/pages/Servers.vue') },
        { path: "/servers/:id", name: 'ServerDetails', component: () => import('@/pages/ServerDetails.vue') },
        { path: "/monitors", name: 'Monitors', component: () => import('@/pages/Monitors.vue') },
        { path: "/monitors/:id", name: 'MonitorDetails', component: () => import('@/pages/MonitorDetails.vue') },
        { path: "/ips", name: 'Ips', component: () => import('@/pages/Ips.vue') },
        { path: "/ips/:id", name: 'IpDetails', component: () => import('@/pages/IpDetails.vue') },
      ]
    },
    {
      path: '/settings',
      component: () => import('@/layouts/Settings.vue'),
      meta: { requiresAuth: true },
      children: [
        { path: '', redirect: { name: 'SettingsPreferences' } },
        { path: 'preferences', name: 'SettingsPreferences', component: () => import('@/pages/settings/Preferences.vue') },
        { path: 'profile', name: 'SettingsProfile', component: () => import('@/pages/settings/Profile.vue') },
        { path: 'notifications', name: 'SettingsNotifications', component: () => import('@/pages/settings/Notifications.vue') },
        { path: 'security', name: 'SettingsSecurity', component: () => import('@/pages/settings/Security.vue') },
        {
          path: 'design-system',
          component: () => import('@/pages/settings/DesignSystem.vue'),
          children: [
            { path: '', name: 'SettingsDesignSystem', redirect: { name: 'SettingsButtonDesignSystem' } },
            { path: 'buttons', name: 'SettingsButtonDesignSystem', component: () => import('@/pages/settings/ButtonDesignSystem.vue') },
            { path: 'combobox', name: 'SettingsDesignSystemCombobox', component: () => import('@/pages/settings/ComboboxDesignSystem.vue') },
            { path: 'select-box', name: 'SettingsDesignSystemSelectBox', component: () => import('@/pages/settings/SelectBoxDesignSystem.vue') },
            { path: 'avatars', name: 'SettingsDesignSystemAvatars', component: () => import('@/pages/settings/AvatarDesignSystem.vue') },
            { path: 'badges', name: 'SettingsDesignSystemBadges', component: () => import('@/pages/settings/BadgeDesignSystem.vue') },
            { path: 'spinner', name: 'SettingsDesignSystemSpinner', component: () => import('@/pages/settings/SpinnerDesignSystem.vue') },
          ],
        },
        { path: 'teams', redirect: { name: 'SettingsPreferences' } },
        { path: 'integrations', name: 'SettingsIntegrations', component: () => import('@/pages/settings/Integrations.vue') },
        { path: 'integrations/:type', name: 'SettingsIntegrationType', component: () => import('@/pages/settings/IntegrationType.vue') },
        {
          path: 'integrations/:type/accounts/:integrationId',
          name: 'SettingsIntegrationAccount',
          component: () => import('@/pages/settings/IntegrationAccountDetails.vue')
        },
        { path: 'teams/:teamId', name: 'SettingsTeamDetails', component: () => import('@/pages/settings/TeamDetails.vue') },
      ],
    },

    {
      path: '/maintenance',
      name: 'Maintenance',
      component: () => import('@/pages/Maintenance.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: '404',
      component: () => import('@/pages/NotFound.vue'),
    }
  ],
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()

  if (to.name === 'Maintenance') {
    next()
    return
  }

  if (to.meta.requiresAuth && !authStore.user) {
    next({ name: "Login" })
  } else if (to.meta.isGuest && authStore.user) {
    next({ name: "Timeline" })
  } else {
    next();
  }

  // next();
});

export default router;
